import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';

function Home() {
  const { user } = useAuth();

  return (
    <div className="home">
      <div className="card" style={{ marginTop: '2rem' }}>
        <h1>Welcome to English Vocabulary Helper</h1>
        <p style={{ margin: '1rem 0' }}>
          This application helps you improve your English vocabulary by processing articles
          and managing your known and learning word lists.
        </p>
        
        {user ? (
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
            <Link to="/process" className="btn">Process an Article</Link>
            <Link to="/vocabulary" className="btn btn-secondary">Manage Vocabulary</Link>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
            <Link to="/login" className="btn">Login</Link>
            <Link to="/register" className="btn btn-secondary">Register</Link>
          </div>
        )}
      </div>

      <div className="card">
        <h2>How It Works</h2>
        <ol style={{ marginLeft: '1.5rem', marginTop: '1rem' }}>
          <li>Paste an English article into the processor</li>
          <li>The system will tokenize the article into unique words</li>
          <li>Words already in your "known words" list will be filtered out</li>
          <li>You can review the remaining words and add them to your known or learning lists</li>
          <li>Each word can be translated to Chinese to help with understanding</li>
        </ol>
      </div>

      <div className="card">
        <h2>Features</h2>
        <ul style={{ marginLeft: '1.5rem', marginTop: '1rem' }}>
          <li>Article processing and word extraction</li>
          <li>Vocabulary management (known words and learning words)</li>
          <li>English to Chinese translation</li>
          <li>User accounts to save your progress</li>
        </ul>
      </div>
    </div>
  );
}

export default Home;
